import { Box, Typography } from "@material-ui/core";
import React from "react";

import { InvestmentStyleDiagnosisRequestShortTermSaleIntentEnum as SaleIntentEnum } from "@/api/generated";
import {
  DIAGNOSIS_QUESTION_TEXT,
  SALE_TIMING_OPTIONS,
} from "@/constants/investmentStyleDiagnosisQuestions";

import { DiagnosisInvestmentStyleCheckboxList } from "../DiagnosisInvestmentStyleCheckboxList";

import { useStepStyles } from "./stepStyles";

type SaleTimingStepProps = {
  shortTermSaleIntent: SaleIntentEnum | null;
  onShortTermSaleIntentChange: (next: SaleIntentEnum | null) => void;
};

const SaleTimingStep: React.FC<SaleTimingStepProps> = ({ shortTermSaleIntent, onShortTermSaleIntentChange }) => {
  const classes = useStepStyles();
  return (
    <>
      <Typography className={classes.title}>売却のタイミングについて</Typography>
      <Typography className={classes.description}>{DIAGNOSIS_QUESTION_TEXT[10]}</Typography>
      <Box className={classes.inputArea}>
        <DiagnosisInvestmentStyleCheckboxList
          options={SALE_TIMING_OPTIONS}
          selected={shortTermSaleIntent ? [shortTermSaleIntent] : []}
          single
          onChange={(next) => onShortTermSaleIntentChange(next[0] ?? null)}
        />
      </Box>
    </>
  );
};

export default SaleTimingStep;
